import { render, staticRenderFns } from "./lessonCompletionBarChart.vue?vue&type=template&id=1e6206e8&scoped=true&lang=html&"
import script from "./lessonCompletionBarChart.vue?vue&type=script&lang=ts&"
export * from "./lessonCompletionBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./lessonCompletionBarChart.vue?vue&type=style&index=0&id=1e6206e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6206e8",
  null
  
)

export default component.exports